import mixitup from 'mixitup';

var buttonFilter = {
  filters: null,
  reset: null,
  container: null,
  sort: null,
  groups: [],
  outputArray: [],
  outputString: '',
  mixer: null,

  init: function() {
    var self = this;

    self.filters = document.getElementById('spoiler-card-filters');
    self.reset = document.querySelectorAll('.filter-group-reset-link');
    self.container = document.querySelector('.spoiler-card-container');
    self.sort = document.querySelectorAll('.sort');

    if (self.filters) {
      self.filters.querySelectorAll('fieldset').forEach(function(fieldset) {
        self.groups.push({
          buttons: fieldset.querySelectorAll('.filter'),
          active: ''
        });
      });
    }

    self.bindHandlers();
  },

  bindHandlers: function() {
    var self = this;

    if (self.filters) {
      self.filters.addEventListener('click', function(e) {
        var button = e.target.closest('.filter');
        if (!button) return;
        e.preventDefault();
        if (button.classList.contains('active')) {
          button.classList.remove('active');
        } else {
          button.classList.add('active');
          button.parentElement.querySelectorAll('.filter').forEach(function(sib) {
            if (sib !== button) sib.classList.remove('active');
          });
        }
        self.parseFilters();
      });
    }

    self.sort.forEach(function(sortEl) {
      sortEl.addEventListener('change', function(e) {
        e.preventDefault();
        if (self.mixer) self.mixer.sort(sortEl.value);
      });
    });

    self.reset.forEach(function(resetEl) {
      resetEl.addEventListener('click', function(e) {
        e.preventDefault();
        if (self.filters) {
          self.filters.querySelectorAll('.filter').forEach(function(btn) {
            btn.classList.remove('active');
          });
        }
        self.parseFilters();
      });
    });
  },

  parseFilters: function() {
    var self = this;
    self.groups.forEach(function(group) {
      var activeBtn = Array.from(group.buttons).find(function(b) { return b.classList.contains('active'); });
      group.active = activeBtn ? (activeBtn.dataset.filter || '') : '';
    });
    self.concatenate();
  },

  concatenate: function() {
    var self = this;
    self.outputString = '';
    self.groups.forEach(function(group) {
      self.outputString += group.active;
    });
    if (!self.outputString.length) self.outputString = 'all';
    if (self.mixer) self.mixer.filter(self.outputString);
  }
};

export { buttonFilter };

window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  buttonFilter.init();

  var container = document.querySelector('.spoiler-card-container');
  if (container) {
    buttonFilter.mixer = mixitup(container, {
      animation: { enable: false },
      controls: { enable: false }
    });
  }

  function filterByString(searchValue) {
    if (!buttonFilter.mixer) return;
    if (searchValue) {
      buttonFilter.mixer.filter('[data-name*="' + searchValue + '"]');
    } else {
      buttonFilter.mixer.filter('all');
    }
  }

  var textFilter = document.querySelector(".spoiler-text-filter");
  if (textFilter) {
    var keyupTimeout;
    textFilter.addEventListener('keyup', function() {
      var searchValue;
      if (textFilter.value.length < 3) {
        searchValue = '';
      } else {
        searchValue = textFilter.value.toLowerCase().trim();
      }
      clearTimeout(keyupTimeout);
      keyupTimeout = setTimeout(function() {
        filterByString(searchValue);
      }, 350);
    });
  }

  document.querySelectorAll(".filter-group-reset-link").forEach(function(el) {
    el.addEventListener('click', function() {
      if (buttonFilter.mixer) buttonFilter.mixer.filter('all');
    });
  });

  document.querySelectorAll(".spoiler-card-unofficial-blocker").forEach(function(el) {
    el.addEventListener('click', function() {
      document.querySelectorAll(".spoiler-card-unofficial-blocker").forEach(function(b) {
        b.style.display = 'none';
      });
    });
  });
});
